<script>
  import { getAllContexts, createEventDispatcher } from 'svelte';
  import { writable } from 'svelte/store';
  import { OrderedSet } from 'immutable';
  import Cancel from './Cancel';

  const dispatch = createEventDispatcher();
  const tasks = writable(new OrderedSet());
  const allContexts = getAllContexts();

  function getProp(prop) {
    return $$props[prop];
  }
  function getContext(key) {
    return allContexts.get(key);
  }

  async function render(component, props) {
    const task = { component, props };
    try {
      return await new Promise((resolve, reject) => {
        task.resolve = resolve;
        task.reject = reject;
        tasks.update((set) => set.add(task));
      });
    } finally {
      tasks.update((set) => set.delete(task));
    }
  }

  const driver = {
    getProp,
    getContext,
    dispatch,
    render,
  };

  export const run = (flow) => flow.task(driver).catch((error) => {
    if (error instanceof Cancel) {
      return;
    }
    throw error;
  });
</script>

{#each [...$tasks] as { component, props, resolve, reject }}
  <svelte:component
    this={component}
    {...props}
    on:return={({ detail }) => resolve(detail)}
    on:cancel={() => reject(new Cancel())} />
{/each}
